import { game as relax } from "./relax.js"
import { game as moorgate } from "./moorgate.js"
import { game as live } from "./livegames.js"
import { incorrectGameId } from "./error-gameid.js";
import { QueryData } from "./!tools/QueryData.compressed.js";

export let rlxlauncher = {};

// GET parameters to getData using QueryData() from QueryData.compressed.js
rlxlauncher.getData = new QueryData();

const removeSEbuttons = [
    102, 202, 261,
];
const interval_RC_partnerids = [
    10, 665, 791,
];
const interval_RC_providers = [
    'high5', 'slingo', 'sw', 'pgsoft', 'ot',
    'sml', 'sm', 'rp', 'st',
];
const interval_RC_partnerids_all_games = [
    2
];
const wrapperjurisdictions = [
    'DE', 'NL'
     ];
const wrappername = {
    'DE': 'de-wrapper',
    'NL': 'nl-wrapper'
};

const moorgatePartnerIds = [
    2135, 2154, 2153,
    2187, 2188, 2189, 2190, 2191, 2192, 2193, 2194, 2195, 2196, 2197, 2198, 2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207, 2208, 2209, 2210, 2211, 2212, 2213, 2214, 2215, 2216, 2217, 2218, 2219, 2220, 2221, 2222, 2223, 2224,
    2167, 2169, //These two are MovingUp partner ids. We should refactor these for clarity later
    2360, 2361, 2362, //Asian Gaming
    2391, 2360, //CDNL-9 || Asian Gaming
    2387 // Niall request 11/21
];

const livegames = [
    'bigbadwolflive', 'bbwl', 'stickybanditsroulette'
];
/*
    TODO: livegames list above might be OK for the moment since we won't suddenly have 20 live
    games to take off in the near future.
    we probably want to make it easier to update (seperate .json file)
    or put this info in the platform
*/

const incorrectGameIds = [
    'epicfishadventure',
    'epicfishadventure94',
    'epicfishadventure92',
    'epicfishadventure87',
    'epicfishnetoffortune87'
];

export async function launchgame(settings) {
    if ('jurisdiction' in rlxlauncher.getData) {
        if (
            (removeSEbuttons.indexOf(parseInt(rlxlauncher.getData.partnerid)) != -1) &&
            rlxlauncher.getData.jurisdiction.toUpperCase() == 'SE'
        ) {
            delete rlxlauncher.getData.rg_st_uri;
            delete rlxlauncher.getData.rg_sl_uri;
            delete rlxlauncher.getData.rg_se_uri;
            delete rlxlauncher.getData.rg_panic_uri;
        }
        if (
            (rlxlauncher.getData.jurisdiction.toUpperCase() == 'DE') &&
            ('rg_panic_uri' in rlxlauncher.getData) &&
            (rlxlauncher.getData.gameid.indexOf('rlx.') == 0) &&
            !('deWrapped' in rlxlauncher.getData)
        ) {
            if ('homeurl' in rlxlauncher.getData) {
                if (!(rlxlauncher.getData.homeurl.substring(0, 7) == 'action:')) {
                    rlxlauncher.getData.homeurl = 'action:' + rlxlauncher.getData.homeurl;
                }
            }
            if ('rchistoryurl' in rlxlauncher.getData) {
                if (!(rlxlauncher.getData.rchistoryurl.substring(0, 7) == 'action:')) {
                    rlxlauncher.getData.rchistoryurl = 'action:' + rlxlauncher.getData.rchistoryurl;
                }
            }
            let wrappedurl = '';
            for (let key in rlxlauncher.getData) {
                wrappedurl += key + '=' + rlxlauncher.getData[key] + '&';
            }
            return('/casino/de-wrapper/?gameUrl=' +
                location.protocol + '//' +
                location.hostname +
                location.pathname + '&' + wrappedurl + 'deWrapped=1');
        }
        let jurisdiction = rlxlauncher.getData.jurisdiction.toUpperCase();
        if (
            (wrapperjurisdictions.indexOf(jurisdiction) != -1) &&
            ( ('rg_account_uri' in rlxlauncher.getData) || ('rg_panic_uri' in rlxlauncher.getData) ) &&
            (rlxlauncher.getData.gameid.indexOf('rlx.') == 0) &&
            (window.location.href.indexOf('Wrapped=1') == -1)
        ) {
            if ('homeurl' in rlxlauncher.getData) {
                if (!(rlxlauncher.getData.homeurl.substring(0, 7) == 'action:')) {
                    rlxlauncher.getData.homeurl = 'action:' + rlxlauncher.getData.homeurl;
                }
            }
            if ('rchistoryurl' in rlxlauncher.getData) {
                if (!(rlxlauncher.getData.rchistoryurl.substring(0, 7) == 'action:')) {
                    rlxlauncher.getData.rchistoryurl = 'action:' + rlxlauncher.getData.rchistoryurl;
                }
            }
            let wrapperParams;
            if ('rg_account_uri' in rlxlauncher.getData) {
                wrapperParams += '&rg_account_uri=' + encodeURIComponent(rlxlauncher.getData.rg_account_uri);
            }
            else if ('rg_panic_uri' in rlxlauncher.getData) {
                wrapperParams += '&rg_panic_uri=' + encodeURIComponent(rlxlauncher.getData.rg_panic_uri);
            }
            if ('accountlabel' in rlxlauncher.getData) {
                wrapperParams += '&accountlabel=' + encodeURIComponent(rlxlauncher.getData.accountlabel);
            }
            let wrappedurl = '';
            for (let key in rlxlauncher.getData) {
                wrappedurl += key + '=' + rlxlauncher.getData[key] + '&';
            }
            return('/casino/' + wrappername[jurisdiction] +
                '/?Wrapped=1' + wrapperParams + '&gameUrl=' +
                location.protocol + '//' +
                location.hostname +
                location.pathname + '&' + wrappedurl);
        }
    }
    if ('partnerid' in rlxlauncher.getData) {
        if (interval_RC_partnerids.indexOf(parseInt(rlxlauncher.getData.partnerid)) != -1) {
            if ('gameid' in rlxlauncher.getData) {
                rlxlauncher.getData.gameid = rlxlauncher.getData.gameid.toLowerCase();
                let split = rlxlauncher.getData.gameid.split('.');
                let provider = split[1];
                if (interval_RC_providers.indexOf(provider) != -1) {
                    if (
                        (!('rcenable' in rlxlauncher.getData) || rlxlauncher.getData.rcenable !== 'true') &&
                        ('rcinterval' in rlxlauncher.getData && rlxlauncher.getData.rcinterval)
                    ) {
                        let rcparams = '[' + rlxlauncher.getData.rcinterval + ',' + rlxlauncher.getData.rcelapsed + ']';
                        rlxlauncher.getData.rciframeurl = location.protocol + '//' + location.hostname + '/casino/relaxlibs/interval_rc_popup.html?rcparams=' + rcparams;
                        rlxlauncher.getData.rcenable = 'true';
                        delete rlxlauncher.getData.rcelapsed;
                        delete rlxlauncher.getData.rcinterval;
                    }
                }
            }
        }
        else if (interval_RC_partnerids_all_games.indexOf(parseInt(rlxlauncher.getData.partnerid)) != -1) {
            if (
                (!('rcenable' in rlxlauncher.getData) || rlxlauncher.getData.rcenable !== 'true') &&
                ('rcinterval' in rlxlauncher.getData && rlxlauncher.getData.rcinterval)
            ) {
                let rcparams = '[' + rlxlauncher.getData.rcinterval + ',' + rlxlauncher.getData.rcelapsed + ']';
                rlxlauncher.getData.rciframeurl = location.protocol + '//' + location.hostname + '/casino/relaxlibs/interval_rc_popup.html?rcparams=' + rcparams;
                rlxlauncher.getData.rcenable = 'true';
                delete rlxlauncher.getData.rcelapsed;
                delete rlxlauncher.getData.rcinterval;
            }
        }
    }
    if ('rciframeurl' in rlxlauncher.getData) {
        if (
            (rlxlauncher.getData.rciframeurl.toLowerCase().indexOf('https:') !== 0) &&
            (rlxlauncher.getData.rciframeurl.toLowerCase().indexOf('http:') !== 0)
        ) {
            delete rlxlauncher.getData.rciframeurl;
        }
    }
    if ('clientid' in rlxlauncher.getData) {
        if (rlxlauncher.getData.clientid == rlxlauncher.getData.ticket) {
            rlxlauncher.getData.clientid = '';
        }
    }
    if ('gameid' in rlxlauncher.getData) {
        rlxlauncher.getData.gameid = rlxlauncher.getData.gameid.toLowerCase();
        rlxlauncher.gameid = rlxlauncher.getData.gameid;
        rlxlauncher.partnerid = rlxlauncher.getData.partnerid;

        if (livegames.indexOf(rlxlauncher.gameid) != -1) {
            return live(rlxlauncher);
        } else if (moorgatePartnerIds.indexOf(parseInt(rlxlauncher.partnerid)) != -1) {
            return moorgate(rlxlauncher, settings);
        } else if (incorrectGameIds.indexOf(rlxlauncher.gameid) != -1) {
            return await incorrectGameId(rlxlauncher, settings);
        } else if (rlxlauncher.gameid.length > 0) {
            const result = await relax(rlxlauncher, settings);
            return result;
        } else {
            throw new Error('error: empty gameid parameter.');
        }
    } else {
        throw new Error('error: gameid parameter missing.');
    }
};
